
class ColorPicker {

    constructor() {

        this.element = '.pickcolor';

        this.bindChangeColor();

    }

    bindChangeColor() {
        $(document).ready(() => {

            $(this.element).click(event => {
                $(this.element).removeClass('selected');
                $(event.currentTarget).addClass('selected');

                $(event.currentTarget).parent().find('input[type="hidden"]').val($(event.currentTarget).data('color'));
                $(event.currentTarget).parent().find('input[type="hidden"]').trigger('change');
            });

        });
    }
}

export const colorPicker = new ColorPicker();